import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
// 引入 ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
// 引入 echarts
import * as echarts from "echarts";
import 'echarts-liquidfill'
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
